import { stringRemoveWhitespace } from '../string/stringRemoveWhitespace.js';
import { stringRemoveCustomSingleLineComments } from '../string/stringRemoveCustomSingleLineComments.js';
export function regexStringRemoveCommentsAndWhitespace(regex) {
    // remove comment lines (lines beginning with '#');
    regex = stringRemoveCustomSingleLineComments(regex, '#');
    // remove whitespace
    regex = stringRemoveWhitespace(regex);
    return regex;
}
//# sourceMappingURL=regexStringRemoveCommentsAndWhitespace.js.map